const apiUrl = process.env.REACT_APP_API_URL;
export const PostInscripcionsIdAutoritzacions = async ( json: any , id : string, page : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8071/inscripcions/${id}/autoritzacions`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(json)
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
